export default __webpack_public_path__ + "static/media/book.f1b49a07.png";